/*=========================================================================================
  File Name: moduleUnit.js
  Description: Units Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from "./moduleAmenityState";
import mutations from "./moduleAmenityMutations";
import actions from "./moduleAmenityActions";
import getters from "./moduleAmenityGetters";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
